export const CONSIDERATION_TYPES = Object.freeze({
  DRAFT: 'draft',
  WITH_INSURANCE: 'with_insurance',
  WITHOUT_INSURANCE: 'without_insurance',
  WITH_GUARANTOR: 'with_guarantor',
});

export const INSURANCE_PROVIDERS = {
  SILK_ROAD: 'silk_road',
  DORDOI: 'dordoi',
  UNSPECIFIED: 'unspecified',
  WITHOUT_INSURANCE: 'without_insurance',
};
